
import hljs from 'highlight.js';
import 'highlight.js/styles/monokai-sublime.css'

export const Container = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
    ['link', 'image'],
    //['link', 'image', 'video'],
    ['link'],
    ['clean']                                         // remove formatting button
];

export const imgmodules = {
    toolbar: {
        container: [
            ['image'],
        ]
    }
}


hljs.configure({
    languages: ["javascript", "HTML", "css"],
});

export const txtmodules = {
    syntax: {
        highlight: (text) => hljs.highlightAuto(text).value,
    },
    toolbar: {
        container: [
            ['bold', 'italic', 'underline'],
            ['link', 'code-block', { 'color': [] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
        ]
    }
}

export const sxmodules = {
    toolbar: {
        container: [
            ['bold', 'italic', 'underline']
        ]
    },
    clipboard: {
        matchVisual: false
    }
}

export const modules = {
    toolbar: {
        container: Container,
        'emoji-toolbar': true,
        'emoji-textarea': true,
        'emoji-shortname': true
    },
    clipboard: {
        matchVisual: false
    }
};

export const formats = [
    'header', 'font', 'size', 'color',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullte', 'indent', 'align', 'ordered', 'script',
    'link', 'image', 'video', 'background', 'emoji', 'code-block'
];

export const removeSpace = ({ text, term }) => {
    if (text && term) {
        let newText = text.trim() + "<end></end>";
        let endTerm = `${term}<end></end>`;
        if (newText.includes(endTerm)) {
            newText = newText.replace(endTerm, "");
            return removeSpace({ text: newText, term });
        }
        return text;
    }
    return "";
}